import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import store from "../../../store/store";
import { addBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import AddProduct from "../EditCategory";
import { brandsAsyncThunk, categoryAsyncThunk, tagsAsyncThunk } from "../../Products/reducer/productSlice";
import { fetchCategoryById, reset } from "../reducer/categoryDetailsSlice";
import { Bars } from "react-loader-spinner";

const InitMiddlewareEditCategory:React.FC<any> = (props) => {
  const { categoryDetails, isLoading, isSuccess, editCategoryRes } = useSelector(
    (state: any) => state.rootReducer?.categoryDetail
  );
  const navigate = useNavigate();

  let { categoryId } = useParams();

  useEffect(() => {
    if (categoryId) {
      store.dispatch(fetchCategoryById(categoryId));
    }

    return () => {
      store.dispatch(reset())
    }
  }, [categoryId]);

  useEffect(() => {
    const data: any = [
      {
        label: "Categories",
        link: `/categories`,
      },
      {
        label: "Edit category",
        link: ``,
      },
    ];
    store.dispatch(addBreadcrumb(data));
  }, []);

    if (isLoading.categoryDetails) {
      return (
        <div className="flex items-center justify-center w-full h-screen">
          <Bars
            height="80"
            width="80"
            color="#2460a2"
            ariaLabel="bars-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
      );
    }
  

  if (isSuccess && editCategoryRes?.data?.success === true) {
    navigate("/categories")
    return null;
  } else {
    return <AddProduct {...props} />;
  }
};

export default InitMiddlewareEditCategory;
